/**
 * Device color palette for chart visualization
 *
 * These colors are used across chart components to consistently
 * represent different data sources (devices/collectors).
 */

export const DEVICE_COLORS: Record<string, string> = {
  // Water test devices
  aquawiz: '#9b59b6',      // Purple - AquaWiz KH1
  alkatronic: '#ff7f0e',   // Orange - Focustronic Alkatronic
  mastertronic: '#d62728', // Red - Focustronic Mastertronic
  aquarimate: '#3498db',   // Blue - Aquarimate

  // Apex sensors
  apex: '#51cf66',         // Green - Apex Fusion

  // Manual entries
  manual: '#9b59b6',       // Purple - User-entered data

  // Temperature (Apex)
  temperature: '#ff6b6b',  // Coral red

  // pH sources
  ph_apex: '#2ca02c',      // Green - Apex pH probe
};

/**
 * Get color for a device/source, with fallback
 */
export function getDeviceColor(source: string | null | undefined): string {
  if (!source) return '#6B7280'; // Gray fallback
  return DEVICE_COLORS[source.toLowerCase()] || '#6B7280';
}
